/**
 * Read JWT `exp` (seconds since epoch) from an access token without verifying the signature.
 * Used only for client-side scheduling (proactive refresh), not for authorization decisions.
 */
export function getJwtExpiryMs(accessToken: string): number | null {
  try {
    const parts = accessToken.split('.')
    if (parts.length < 2) {
      return null
    }
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    const json = atob(padded)
    const payload = JSON.parse(json) as { exp?: number }
    if (typeof payload.exp !== 'number' || !Number.isFinite(payload.exp)) {
      return null
    }
    return payload.exp * 1000
  } catch {
    return null
  }
}
